import { HttpInterceptorFn } from '@angular/common/http';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  // Get the token using the same key as in AuthService
  const token = localStorage.getItem('AuthorizationKey');
  // Skip adding token for auth requests
  if (req.url.includes('/auth/')) {
    return next(req);
  }

  if (token) {
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
    return next(authReq);
  }
  return next(req);
};
